// Private keys stay in tab memory and, without preference cookies, the private URL fragment.
// Fragments are not sent as part of HTTP requests or Referer headers.
const keys = new Map<string, string>();
export function rememberRoomLink(link: string) {
  const url = new URL(link, window.location.origin);
  const id = url.searchParams.get("id");
  const key = new URLSearchParams(url.hash.slice(1)).get("key");
  if (id && key && /^[A-Za-z0-9_-]{43}$/.test(key)) keys.set(id, key);
}
export function roomHeaders(id: string, initial?: HeadersInit): Headers {
  rememberRoomLink(window.location.href);
  const headers = new Headers(initial);
  const key = keys.get(id);
  if (key) headers.set("Authorization", `Bearer ${key}`);
  return headers;
}
export function retainCurrentRoomLink() {
  rememberRoomLink(window.location.href);
  const url = new URL(window.location.href);
  const id = url.searchParams.get("id");
  const key = id && keys.get(id);
  if (key) {
    url.hash = new URLSearchParams({ key }).toString();
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
  }
}
